<template>
    <form @change="sendDataForSaving">
        <div class="row">

            <ValidationProvider
                name="Work experience in Orna"
                rules="required"
                v-slot="{ errors }"
                class="col-md-6"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">Have you worked at ORNA in the past?</label>
                    <div class="buttons-type-multiselect two-btns">
                        <div class="item">
                            <input
                                type="radio"
                                name="name1"
                                class="rad"
                                id="id-12"
                                value="1"
                                v-model="form.worked_in_orna">
                            <label for="id-12">
                                <div class="ttl">Yes</div>
                            </label>
                        </div>
                        <div class="item">
                            <input
                                type="radio"
                                name="name1"
                                class="rad"
                                id="id-13"
                                value="0"
                                v-model="form.worked_in_orna"
                            >
                            <label for="id-13">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                        <FormError :error="errors[0]"  name="Work experience in Orna"></FormError>
                    </div>
                </div>
            </ValidationProvider>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">How did you hear about ORNA?</label>
                    <div class="form-group form-group-1">
                        <select
                            class="custom-select"
                            v-model="form.how_hear_id"
                            @change="handleSelectChange"
                        >
                            <option
                                :value="variant.id"
                                v-for="variant in variantsList"
                            >
                                {{ variant.title }}
                            </option>
                            <option value="null">Other</option>
                        </select>
                    </div>
                    <div v-show="isChosenOther">
                        <ValidationProvider
                            name="How hear: other" v-slot="{errors}"
                            rules="latinAndNumbers|min:2|max:500"
                            class="form-group form-group-1"
                        >
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Type Other"
                                v-model="form.how_hear_other"
                            >
                            <FormError :error="errors[0]"  name="How hear: other" ></FormError>
                        </ValidationProvider>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group form-group-1">
                    <label for="" class="form-label">
                        Do you know anyone who currently works for or used to work for
                        ORNA?
                    </label>
                    <div class="buttons-type-multiselect two-btns">
                        <div class="item">
                            <input
                                type="radio"
                                name="name2"
                                class="rad"
                                id="id-113"
                                value="1"
                                v-model="form.familiar_in_orna"
                            >
                            <label for="id-113">
                                <div class="ttl">Yes</div>
                            </label>
                        </div>
                        <div class="item">
                            <input
                                type="radio"
                                name="name2"
                                class="rad"
                                @click="clearField"
                                id="id-121"
                                value="0"
                                v-model="form.familiar_in_orna"
                            >
                            <label for="id-121">
                                <span class="ttl">No</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <ValidationProvider
                name="Familiar details"
                v-slot="{errors}"
                rules="latinAndNumbers|min:2|max:500"
                v-if="form.familiar_in_orna === 1 "
                class="col-md-6"
            >
                <div class="form-group form-group-1">
                    <label for="" class="form-label">
                        If yes, Who?
                    </label>
                    <input
                        type="text"
                        class="form-control"
                        v-model="form.familiar_person_info"
                    >
                </div>
                <FormError :error="errors[0]" name="Familiar details"></FormError>
            </ValidationProvider>
        </div>
    </form>

</template>

<script>
import VueMultiSelect from "../../../../../../resources/js/plugins/VueMultiSelect.vue";

export default {
    name: 'PreviousOrnaWorkExp',
    components: {VueMultiSelect},
    emits: ['data-changed'],
    props: {
        user: {
            type: Object,
            required: true
        },
        variantsList: {
            type: Array,
        },
    },
    data() {
        return {
            form: {
                worked_in_orna: null,
                how_hear_id: null,
                how_hear_other: null,
                familiar_in_orna: null,
                familiar_person_info: null
            },
        }
    },
    computed: {
        isChosenOther() {
            if (this.form.how_hear_id=== null) {
                return true
            } else {
                this.form.how_hear_other = null
            }
        },
    },
    methods: {
        handleSelectChange() {
            if (this.form.how_hear_id=== "null") {
                this.form.how_hear_id= null;
            }
        },
        setData() {
            for (const userKey in this.user.work_experience) {
                for (const formKey in this.form) {
                    if (userKey === formKey) {
                        this.form[userKey] = this.user.work_experience[formKey];
                    }
                }
            }
        },
        sendDataForSaving() {
            this.$emit('data-changed', this.form);
        },
        clearField() {
            this.form.familiar_person_info = null;
        }
    },
    mounted() {
        this.setData()
        if (this.user.work_experience) {
            this.form.how_hear_id = this.user.work_experience.how_hear_id;
        } else {
            this.form.how_hear_id = 1
        }
    },
    watch: {
        'form.familiar_in_orna': function (newValue) {
            this.form.familiar_in_orna = Number(newValue);
        },
        'form.worked_in_orna': function (newValue) {
            this.form.worked_in_orna = Number(newValue);
        },
    },
}

</script>


<style scoped>

</style>
